import { Box, Pagination, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Helix styled Pagination component.
 */
export const HelixBasicPaging = styled(Pagination)(() => ({
    transition: 'none',
    '.MuiButtonBase-root': Object.assign(Object.assign({}, HelixStyles.style_07), { border: `2px solid transparent`, svg: {
            fill: HelixPalette.neutral90,
            transition: 'none',
        }, transition: 'none', '&:hover': {
            backgroundColor: HelixPalette.teal40,
            borderColor: HelixPalette.teal40,
            color: HelixPalette.white,
            svg: { fill: HelixPalette.white },
        }, '&:active:focus:not([aria-current=true])': {
            backgroundColor: HelixPalette.teal60,
            borderColor: HelixPalette.teal60,
            color: HelixPalette.white,
            svg: { fill: HelixPalette.white },
        }, '&[aria-current=true],&[aria-current=true]:hover': {
            backgroundColor: HelixPalette.teal50,
            borderColor: HelixPalette.teal50,
            color: HelixPalette.white,
            svg: { fill: HelixPalette.white },
        }, '&:focus-visible:not([aria-current=true])': {
            backgroundColor: HelixPalette.white,
            borderColor: HelixPalette.blue70,
            color: HelixPalette.neutral90,
            svg: { fill: HelixPalette.neutral90 },
        } }),
}));
/**
 * Styles Box to contain the paging controls.
 */
export const PagingBox = styled(Box)(() => ({
    alignItems: 'center',
    display: 'flex',
}));
